module.exports = __webpack_public_path__ + "static/media/learn-play-icon-black.89bd262d.svg";